import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/components/layout/Layout";
import PosLoginView from "@/views/point-of-sale/PosLoginView";
import store from "../store/index";
import {Storage} from "@/services/Storage";
import POSView from "@/views/point-of-sale/POSView";
import Quotes from "@/views/point-of-sale/Accounts/Quotes";
import SelectCustomerView from "@/views/point-of-sale/Accounts/SelectCustomerView";
import UserLogin from "@/views/UserLogin.vue";
import OtpLogin from "@/views/OtpLogin.vue";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: "poslogin",
        component: PosLoginView
    },
    {
        path: '/',
        name: "UserLogin",
        component: UserLogin
    },
    {
        path: '/',
        name: "OtpLogin",
        component: OtpLogin
    },

    {

        path: '/',
        component: Layout,
        children: [
            {
                path: '/pos',
                name: 'pos',
                component: POSView,
            },
            {
                path: '/view-sale',
                name: 'viewSale',
                component: () => import(/* webpackChunkName: "ViewSale" */'../views/point-of-sale/sale/ViewSaleView')
            },
            {
                path: '/instruction/:plu',
                props: true,
                name: "instruction",
                component: () => import(/* webpackChunkName: "float" */ '../views/point-of-sale/cookingInstruction/CookingInstruction'),
            },




            {
                path: '/sales-records',
                name: "salesRecords",
                component: () => import(/* webpackChunkName: "salesRecords" */ '../views/point-of-sale/SalesRecordsView'),
            },
            {
                path: '/settings',
                name: "settings",
                component: () => import(/* webpackChunkName: "settings" */ '../views/boffice/settings/SettingsView'),
            },



            {
                path: '/tables',
                name: "tables",
                component: Quotes,
            },
            {
                path: '/select-customer',
                name: "select-customer",
                component: SelectCustomerView,
            },

            {
                path: '/create-debtor',
                name: "create-debtor",
                component: () => import(/* webpackChunkName: "create-debtor" */ '../views/point-of-sale/Accounts/CreateDebtorView'),
            },
        ]
    },


    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "Login"*/ '../views/LoginView.vue'),
    },
    {
        path: '/setup',
        name: 'setup',
        component: () => import(/* webpackChunkName: "setup"*/ '../views/setup/AppSetupLogin.vue')
    },
    {
        path: '*',
        name: "notfound",
        component: () => import(/* webpackChunkName: "payment-view" */ '../views/point-of-sale/PosLoginView.vue')
    },

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach(async (to, from, next) => {
    if (to.query.quoteData) {
        $utils.showLoading()
        let quoteData = window.atob(to.query.quoteData);
        quoteData = JSON.parse(quoteData);
        await Storage.setAdminUser(quoteData.mobileUser)
        await store.commit("setDefaultStore", quoteData.store);
        try {
            await store.dispatch(`syncData`)
                .then(async () => {
                    let isLoggedIn = await store.dispatch('loginByUserName', quoteData.user)
                    if (!isLoggedIn) {
                        return responses.throwErr(`Incorrect Password`)
                    }

                    let debtors = [];
                    if (quoteData.debtors) {
                        debtors = quoteData.debtors;
                        store.commit('setDebtors', debtors)
                    }

                    if (quoteData.customerID){
                        let currentDebtor = debtors.find(deb=>deb.Id === quoteData.customerID);
                        store.commit(`setCurrentDebtorPriceType`,{
                            DiscountType : currentDebtor.DiscountType,
                            DiscountAmount : currentDebtor.DiscountAmount,
                        });
                        store.commit('setCustomer',quoteData.customerID)
                        if (quoteData.currency) store.commit('setDebtorCurrency',quoteData.currency)
                    }
                    if (quoteData.quoteID){
                        console.log(quoteData.quoteID)
                        try {
                            await store.dispatch(`getTableBySaleNumber`,quoteData.quoteID)
                        }catch (e) {}
                    }
                    next({name :'pos'} )
                }).finally(() => $utils.hideLoading())
        } catch (e) {
            errorHandler.throwTimeOut();
        }
    } else {
        let exceptions = routeExceptions;
        if (!exceptions.includes(to.name)) {
            let res = await auth.isAdminLoggedIn()
            if (!res) next({name: 'login'})
            else next()
        } else {
            next()
        }
    }

})


export default router
